import { deserializeXY } from "../../serialization";
import type { XY } from "../../xy";
import { Floor } from "./floor";

export class GrassTiledFloor extends Floor {
	static key = "GrassTiledFloor";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): GrassTiledFloor {
		const f = new GrassTiledFloor(deserializeXY(data.xy));
		f.visualId = data.visualId;
		return f;
	}
}
